<template>
  <a-drawer width="60%" :visible="open" :title="formTitle" @cancel="onClose" @close="onClose" :destroyOnClose="true">
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-divider orientation="left"><b>{{ $t('平台分账接收方.基础信息') }}</b></a-divider>
      <a-form-model-item :label="$t('平台分账接收方.分账接收方名称')" prop="receiverName">
        <a-input v-model="form.receiverName" :maxLength="64" :placeholder="$t('通用.输入.请输入') + $t('平台分账接收方.分账接收方名称')" :disabled="fieldDisabled"/>
      </a-form-model-item>
      <a-form-model-item :label="$t('平台分账接收方.联系手机号')" prop="contactMobile">
        <a-input v-model="form.contactMobile" :maxLength="16" :placeholder="$t('通用.输入.请输入') + $t('平台分账接收方.联系手机号')" :disabled="fieldDisabled"/>
      </a-form-model-item>

      <a-divider orientation="left"><b>{{ $t('平台分账接收方.营业执照信息') }}</b></a-divider>
      <a-form-model-item :label="$t('平台分账接收方.营业执照号码')" prop="licenseNo">
        <a-input v-model="form.licenseNo" :maxLength="32" :placeholder="$t('通用.输入.请输入') + $t('平台分账接收方.营业执照号码')" :disabled="fieldDisabled"/>
      </a-form-model-item>
      <a-form-model-item :label="$t('平台分账接收方.营业执照名称')" prop="licenseName">
        <a-input v-model="form.licenseName" :maxLength="128" :placeholder="$t('通用.输入.请输入') + $t('平台分账接收方.营业执照名称')" :disabled="fieldDisabled"/>
      </a-form-model-item>
      <a-form-model-item :label="$t('平台分账接收方.营业执照照片')" prop="businessLicence">
        <OssUploadSingle v-model="form.businessLicence" type="img" :maxSize="300" :disabled="fieldDisabled"/>
      </a-form-model-item>

      <a-divider orientation="left"><b>{{ $t('平台分账接收方.法人信息') }}</b></a-divider>
      <a-form-model-item :label="$t('平台分账接收方.法人姓名')" prop="legalPersonName">
        <a-input v-model="form.legalPersonName" :maxLength="32" :placeholder="$t('通用.输入.请输入') + $t('平台分账接收方.法人姓名')" :disabled="fieldDisabled"/>
      </a-form-model-item>
      <a-form-model-item :label="$t('平台分账接收方.法人证件类型')" prop="legalPersonCertificateType">
        <a-select v-model="form.legalPersonCertificateType" :placeholder="$t('通用.输入.请选择') + $t('平台分账接收方.法人证件类型')" :disabled="fieldDisabled">
          <a-select-option value="17">{{ $t('平台分账接收方.身份证') }}</a-select-option>
          <a-select-option value="18">{{ $t('平台分账接收方.护照') }}</a-select-option>
          <a-select-option value="19">{{ $t('平台分账接收方.港澳居民来往内地通行证') }}</a-select-option>
          <a-select-option value="20">{{ $t('平台分账接收方.台湾居民来往内地通行证') }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('平台分账接收方.法人证件号')" prop="legalPersonCertificateNo">
        <a-input v-model="form.legalPersonCertificateNo" :maxLength="32" :placeholder="$t('通用.输入.请输入') + $t('平台分账接收方.法人证件号')" :disabled="fieldDisabled"/>
      </a-form-model-item>
      <a-form-model-item :label="$t('平台分账接收方.法人身份证正面')" prop="frIdCardFront">
        <OssUploadSingle v-model="form.frIdCardFront" type="img" :maxSize="300" :disabled="fieldDisabled"/>
      </a-form-model-item>
      <a-form-model-item :label="$t('平台分账接收方.法人身份证反面')" prop="frIdCardBehind">
        <OssUploadSingle v-model="form.frIdCardBehind" type="img" :maxSize="300" :disabled="fieldDisabled"/>
      </a-form-model-item>

      <a-divider orientation="left"><b>{{ $t('平台分账接收方.收款账户信息') }}</b></a-divider>
      <a-form-model-item :label="$t('平台分账接收方.收款账户名称')" prop="acctName">
        <a-input v-model="form.acctName" :maxLength="32" :placeholder="$t('通用.输入.请输入') + $t('平台分账接收方.收款账户名称')" :disabled="fieldDisabled"/>
      </a-form-model-item>
      <a-form-model-item :label="$t('平台分账接收方.收款账户卡号')" prop="acctNo">
        <a-input v-model="form.acctNo" :maxLength="32" :placeholder="$t('通用.输入.请输入') + $t('平台分账接收方.收款账户卡号')" :disabled="fieldDisabled"/>
      </a-form-model-item>
      <a-form-model-item :label="$t('平台分账接收方.收款账户证件类型')" prop="acctCertificateType">
        <a-select v-model="form.acctCertificateType" :placeholder="$t('通用.输入.请选择') + $t('平台分账接收方.收款账户证件类型')" :disabled="fieldDisabled">
          <a-select-option value="17">{{ $t('平台分账接收方.身份证') }}</a-select-option>
          <a-select-option value="18">{{ $t('平台分账接收方.护照') }}</a-select-option>
          <a-select-option value="19">{{ $t('平台分账接收方.港澳居民来往内地通行证') }}</a-select-option>
          <a-select-option value="20">{{ $t('平台分账接收方.台湾居民来往内地通行证') }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('平台分账接收方.收款账户证件号')" prop="acctCertificateNo">
        <a-input v-model="form.acctCertificateNo" :maxLength="32" :placeholder="$t('通用.输入.请输入') + $t('平台分账接收方.收款账户证件号')" :disabled="fieldDisabled"/>
      </a-form-model-item>
      <a-form-model-item :label="$t('平台分账接收方.开户行名称')" prop="acctOpenBankName">
        <a-input v-model="form.acctOpenBankName" :maxLength="64" :placeholder="$t('通用.输入.请输入') + $t('平台分账接收方.开户行名称')" :disabled="fieldDisabled" @blur="handleBankNameBlur"/>
      </a-form-model-item>
      <a-form-model-item :label="$t('平台分账接收方.开户行号')" prop="acctOpenBankCode">
        <a-input v-model="form.acctOpenBankCode" :maxLength="32" :placeholder="$t('通用.输入.请输入') + $t('平台分账接收方.开户行号')" :disabled="fieldDisabled"/>
      </a-form-model-item>
      <a-form-model-item :label="$t('平台分账接收方.清算行号')" prop="acctClearBankCode">
        <a-input v-model="form.acctClearBankCode" :maxLength="32" :placeholder="$t('通用.输入.请输入') + $t('平台分账接收方.清算行号')" :disabled="fieldDisabled"/>
      </a-form-model-item>
      <a-form-model-item :label="$t('平台分账接收方.提款类型')" prop="settleType">
        <a-select v-model="form.settleType" :placeholder="$t('通用.输入.请选择') + $t('平台分账接收方.提款类型')" :disabled="fieldDisabled">
          <a-select-option value="01">{{ $t('平台分账接收方.主动提款') }}</a-select-option>
          <a-select-option value="03">{{ $t('平台分账接收方.交易自动结算') }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('平台分账接收方.银行卡照片')" prop="bankCardImg">
        <OssUploadSingle v-model="form.bankCardImg" type="img" :maxSize="300" :disabled="fieldDisabled"/>
      </a-form-model-item>

      <a-form-model-item :label="$t('平台分账接收方.分账接收方编号')" prop="receiverNo">
        <a-input v-model="form.receiverNo" :placeholder="$t('平台分账接收方.未创建')" disabled="true"/>
      </a-form-model-item>
      <a-form-model-item :label="$t('通用.文本.备注')" prop="remark">
        <a-textarea v-model="form.remark" :rows="3" :maxLength="200" :disabled="fieldDisabled"/>
      </a-form-model-item>
    </a-form-model>

    <div class="bottom-control">
      <a-space>
        <!-- 未创建：本地新增/编辑 -->
        <template v-if="!isCreated">
          <a-button type="primary" :loading="submitLoading" @click="submitForm">{{ $t('通用.按钮.保存') }}</a-button>
          <a-button @click="onClose">{{ $t('通用.按钮.取消') }}</a-button>
        </template>
        <!-- 已创建（存在分账接收方编号）：只读详情，可发起变更 -->
        <template v-else-if="!isEditing">
          <a-button type="primary" @click="handleModify">{{ $t('平台分账接收方.修改分账接收方') }}</a-button>
          <a-button @click="onClose">{{ $t('通用.按钮.取消') }}</a-button>
        </template>
        <!-- 已创建：变更提交态 -->
        <template v-else>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">{{ $t('平台分账接收方.修改分账接收方') }}</a-button>
          <a-button @click="handleCancelModify">{{ $t('通用.按钮.取消') }}</a-button>
        </template>
      </a-space>
    </div>
  </a-drawer>
</template>

<script>
import { getPlatformLedgerReceiver, addPlatformLedgerReceiver, updatePlatformLedgerReceiver, modifyPlatformLedgerReceiver, queryBankBranch } from '@/api/user/platformLedgerReceiver'
import OssUploadSingle from '@/components/OssUploadSingle'

export default {
  name: 'CreateForm',
  components: { OssUploadSingle },
  data() {
    return {
      open: false,
      formTitle: '',
      submitLoading: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      isCreated: false,
      isEditing: false,
      record: {},
      form: {},
      rules: {
        receiverName: [{ required: true, message: this.$t('平台分账接收方.分账接收方名称') + this.$t('通用.文本.不能为空'), trigger: 'blur' }],
        contactMobile: [{ required: true, message: this.$t('平台分账接收方.联系手机号') + this.$t('通用.文本.不能为空'), trigger: 'blur' }],
        licenseNo: [{ required: true, message: this.$t('平台分账接收方.营业执照号码') + this.$t('通用.文本.不能为空'), trigger: 'blur' }],
        licenseName: [{ required: true, message: this.$t('平台分账接收方.营业执照名称') + this.$t('通用.文本.不能为空'), trigger: 'blur' }],
        businessLicence: [{ required: true, message: this.$t('平台分账接收方.营业执照照片') + this.$t('通用.文本.不能为空'), trigger: 'blur' }],
        legalPersonName: [{ required: true, message: this.$t('平台分账接收方.法人姓名') + this.$t('通用.文本.不能为空'), trigger: 'blur' }],
        legalPersonCertificateType: [{ required: true, message: this.$t('平台分账接收方.法人证件类型') + this.$t('通用.文本.不能为空'), trigger: 'change' }],
        legalPersonCertificateNo: [{ required: true, message: this.$t('平台分账接收方.法人证件号') + this.$t('通用.文本.不能为空'), trigger: 'blur' }],
        frIdCardFront: [{ required: true, message: this.$t('平台分账接收方.法人身份证正面') + this.$t('通用.文本.不能为空'), trigger: 'blur' }],
        frIdCardBehind: [{ required: true, message: this.$t('平台分账接收方.法人身份证反面') + this.$t('通用.文本.不能为空'), trigger: 'blur' }],
        acctName: [{ required: true, message: this.$t('平台分账接收方.收款账户名称') + this.$t('通用.文本.不能为空'), trigger: 'blur' }],
        acctNo: [{ required: true, message: this.$t('平台分账接收方.收款账户卡号') + this.$t('通用.文本.不能为空'), trigger: 'blur' }],
        acctCertificateType: [{ required: true, message: this.$t('平台分账接收方.收款账户证件类型') + this.$t('通用.文本.不能为空'), trigger: 'change' }],
        acctCertificateNo: [{ required: true, message: this.$t('平台分账接收方.收款账户证件号') + this.$t('通用.文本.不能为空'), trigger: 'blur' }],
        acctOpenBankName: [{ required: true, message: this.$t('平台分账接收方.开户行名称') + this.$t('通用.文本.不能为空'), trigger: 'blur' }],
        bankCardImg: [{ required: true, message: this.$t('平台分账接收方.银行卡照片') + this.$t('通用.文本.不能为空'), trigger: 'blur' }]
      }
    }
  },
  computed: {
    fieldDisabled() {
      // 已创建且未进入修改态时只读；未创建（新增/编辑）或已进入修改态时可编辑
      return this.isCreated && !this.isEditing
    }
  },
  methods: {
    getBaseForm() {
      return {
        id: undefined,
        receiverName: undefined,
        contactMobile: undefined,
        licenseNo: undefined,
        licenseName: undefined,
        businessLicence: undefined,
        legalPersonName: undefined,
        legalPersonCertificateType: undefined,
        legalPersonCertificateNo: undefined,
        frIdCardFront: undefined,
        frIdCardBehind: undefined,
        acctName: undefined,
        acctNo: undefined,
        acctCertificateType: undefined,
        acctCertificateNo: undefined,
        acctOpenBankName: undefined,
        acctOpenBankCode: undefined,
        acctClearBankCode: undefined,
        settleType: '01',
        bankCardImg: undefined,
        receiverNo: undefined,
        remark: undefined
      }
    },
    handleAdd() {
      this.formTitle = this.$t('通用.按钮.新增')
      this.isCreated = false
      this.isEditing = false
      this.record = {}
      this.form = this.getBaseForm()
      this.open = true
    },
    handleUpdate(record) {
      this.formTitle = this.$t('通用.按钮.详情')
      this.record = { ...record }
      this.form = this.getBaseForm()
      this.isCreated = false
      this.isEditing = false
      getPlatformLedgerReceiver({ id: record.id }).then((response) => {
        this.form = { ...this.getBaseForm(), ...response.data }
        this.isCreated = !!response.data.receiverNo
        this.open = true
      })
    },
    /** 存在分账接收方编号时，点击进入修改分账接收方（调用拉卡拉变更接口） */
    handleModify() {
      this.isEditing = true
      this.formTitle = this.$t('平台分账接收方.修改分账接收方')
    },
    /** 取消修改，回读详情恢复只读 */
    handleCancelModify() {
      this.isEditing = false
      this.formTitle = this.$t('通用.按钮.详情')
      if (this.record.id) {
        getPlatformLedgerReceiver({ id: this.record.id }).then((response) => {
          this.form = { ...this.getBaseForm(), ...response.data }
          this.isCreated = !!response.data.receiverNo
        })
      }
    },
    onClose() {
      this.open = false
    },
    // 开户行名称失焦时，根据名称自动带出开户行号与清算行号
    handleBankNameBlur() {
      if (this.fieldDisabled) {
        return
      }
      const bankName = (this.form.acctOpenBankName || '').trim()
      if (!bankName) {
        return
      }
      queryBankBranch({ bankName }).then((response) => {
        const data = response.data || {}
        if (data.acctOpenBankCode) {
          this.form.acctOpenBankCode = data.acctOpenBankCode
        }
        if (data.acctClearBankCode) {
          this.form.acctClearBankCode = data.acctClearBankCode
        }
      }).catch(() => {})
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return
        }
        this.submitLoading = true
        const data = { ...this.form }
        let request
        let message
        if (this.isCreated) {
          // 已创建分账接收方：调用拉卡拉变更接口
          request = modifyPlatformLedgerReceiver(data)
          message = this.$t('平台分账接收方.变更成功')
        } else {
          request = this.form.id ? updatePlatformLedgerReceiver(data) : addPlatformLedgerReceiver(data)
          message = this.form.id ? this.$t('通用.文本.修改成功') : this.$t('通用.文本.新增成功')
        }
        request
          .then(() => {
            this.$message.success(message)
            this.onClose()
            this.$emit('ok')
          })
          .finally(() => {
            this.submitLoading = false
          })
      })
    }
  }
}
</script>

<style scoped>
.bottom-control {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 4px 4px;
}
</style>
